import { profile } from 'data/bio';
import styles from './profilesection.module.scss';

const ProfileSection: React.FC = () => {
  return (
    <section id="profile-section-root" className={styles.profileSectionRoot}>
      <div className={`${styles.gridItem} ${styles.header1}`}>profile</div>
      <div className={`${styles.gridItem} ${styles.header2}`}>{profile.title}</div>
      <div className={`${styles.gridItem} ${styles.colLeft} ${styles.bioImg}`}></div>
      <div className={`${styles.gridItem} ${styles.colRight}`}>
        <h1>{profile.name}</h1>
        {profile.bio.map((para, i) => <p key={i}>{para}</p>)}
      </div>
      <div className={`${styles.gridItem} ${styles.footer}`}>
        {profile.tagline}
      </div>
    </section>
  );
};

export default ProfileSection;
